<ng-container
  *ngIf="(allInstrumentsIsPending$ | async) === false; else loadingUi"
>
  <prlw-all-table-ui
    *ngIf="availableFeature$ | async; else plug"
    [data]="data$ | async"
    [columns]="columns$ | async"
    [modifiers]="modifiers$ | async"
    [destination]="destination$ | async"
    [overflows]="overflows$ | async"
    (initResizeObserver)="initResizeObserver($event)"
    (setScrollHorizontalPosition)="setScrollHorizontalPosition($event)"
    (setScrollVerticalPosition)="setScrollVerticalPosition($event)"
    (sortColumn)="sortColumn($event)"
    (updateColumn)="updateColumn($event)"
    (eventOnLoaded)="pagePreloaderService.emit()"
  >
  </prlw-all-table-ui>
  <ng-template #plug>
    <prlw-light-mode-overlay></prlw-light-mode-overlay>
  </ng-template>
</ng-container>
<ng-template #loadingUi>
  <prlw-all-table-loading-ui></prlw-all-table-loading-ui>
</ng-template>
